














































import { Vue, Prop, Component, Watch } from 'vue-property-decorator'
import { Icon } from 'vant'
@Component({
  components: {
    [Icon.name]: Icon
  }
})
export default class Video extends Vue {
  @Prop({ default: '' })
  readonly src!: string
  @Prop({ default: '' }) readonly poster!: string
  @Prop({ default: true }) readonly canPlay!: boolean

  displayVideo = false // 是否显示视频
  playing = false // 视频播放状态
  hasPlaying = false // 是否已经在播放，或者暂停,只在点击播放或者暂停按钮控制
  hasDashBoard = false // 是否显示控制面板
  curTime = '00:00' // 秒
  allTime = '00:00'
  hasMuted = false // 是否静音
  timer: number | null = null
  showFullIcon = false // 是否显示全屏图标
  isLoading = false
  isError = false

  created() {
    // 判断是否支持全屏
    const isIOS = window.navigator.userAgent.indexOf('iPhone OS') > -1
    if (isIOS) {
      this.showFullIcon = true
    }
    this.$emit('playing', false)
    // eslint-disable-next-line vue/custom-event-name-casing
    this.$emit('x5FullScreen', false)
  }

  @Watch('canPlay')
  watchCanPlay(val: boolean) {
    if (this.hasPlaying) {
      if (val) {
        this.play()
      } else {
        this.pause()
      }
    }
  }

  @Watch('src')
  watchSrc() {
    const v: any = this.$refs.videoPlayer
    v.currentTime = 0
    this.hideVideo()
    this.hideDashBoard()
    this.playing = false
    this.hasPlaying = false
  }

  @Watch('displayVideo')
  watchDisplayVideo() {
    // eslint-disable-next-line vue/custom-event-name-casing
    this.$emit('showVideo', this.displayVideo)
  }

  init() {
    const v: any = this.$refs.videoPlayer
    const player = v.parentNode.parentNode
    const control_bar = player.querySelector('.video-dashboard')
    const mask_trigger = player.querySelector('.video-mask-trigger')
    v.src = v.getAttribute('lazy-src')
    this.showLoading()
    this.controlPlay()
    v.addEventListener('loadedmetadata', () => {
      this.allTime = this.reverseTime(v.duration)
    })
    v.addEventListener('ended', () => {
      this.over()
      this.playing = false
      this.hasPlaying = false
      // 关闭全屏？
      this.closeFullScreen()
    })
    v.addEventListener('play', () => {
      this.$emit('playing', true)
      this.playing = true
      this.timer = setTimeout(() => {
        if (control_bar) {
          control_bar.classList.add('video-opacity-hidden')
        }
      }, 3000)
    })
    v.addEventListener('pause', () => {
      this.$emit('playing', false)
      this.playing = false
      if (this.timer) {
        clearTimeout(this.timer)
      }
      if (control_bar) {
        control_bar.className = 'video-dashboard'
      }
    })
    v.addEventListener('error', () => {
      this.hideLoading()
      this.hideVideo()
      this.showError()
    })
    // v.addEventListener('stalled', (e) => {
    //     this.hideLoading()
    //     this.hideVideo()
    //     this.showError()
    // })
    v.addEventListener('playing', () => {
      this.hideLoading()
    })
    // 提示该视频已准备好开始播放
    v.addEventListener('loadeddata', () => {
      // this.play()
    })
    v.addEventListener('timeupdate', () => {
      const cur_position = v.currentTime
      const percentage = (100 * cur_position) / v.duration
      const progressBar = v.parentNode.parentNode.querySelector('.progress-play')
      if (progressBar) {
        progressBar.style.width = `${percentage}%`
      }
      this.curTime = this.reverseTime(cur_position)
      if (this.allTime === '00:00') {
        this.allTime = this.reverseTime(v.duration)
      }
    })
    // 微信x5全屏
    v.addEventListener('x5videoenterfullscreen', () => {
      // eslint-disable-next-line vue/custom-event-name-casing
      this.$emit('x5FullScreen', true)
    })
    // 微信x5退出全屏
    v.addEventListener('x5videoexitfullscreen', () => {
      // eslint-disable-next-line vue/custom-event-name-casing
      this.$emit('x5FullScreen', false)
    })
    if (mask_trigger) {
      mask_trigger.addEventListener('click', () => {
        if (this.timer) {
          clearTimeout(this.timer)
        }
        control_bar.className = 'video-dashboard'
        this.timer = setTimeout(() => {
          if (control_bar) {
            control_bar.classList.add('video-opacity-hidden')
          }
        }, 4500)
      })
    }
    if (control_bar) {
      control_bar.addEventListener('transitionend', () => {
        if (control_bar.classList.contains('video-opacity-hidden')) {
          control_bar.classList.add('video-hidden')
        } else {
          control_bar.className = 'video-dashboard'
        }
      })
    }
  }
  reverseTime(seconds: any) {
    let minutes = Math.floor(seconds / 60)
    let time = ''
    if (minutes < 10) {
      time = `0${minutes}`
    }
    return `${time}:${((seconds % 60) / 100).toFixed(2).slice(-2)}`
  }
  over() {
    this.hideVideo()
    this.hideDashBoard()
  }
  clickPlayBtn() {
    this.init()
    this.showVideo()
    this.showDashBoard()
  }
  controlPlay() {
    const v = this.$refs.videoPlayer as HTMLVideoElement
    if (v.paused || v.ended) {
      // 暂停时点击就播放
      if (v.ended) {
        // 如果播放完毕，就重头开始播放
        v.currentTime = 0
      }
      v.play()
      this.playing = true
      this.hasPlaying = true
    } else {
      v.pause()
      this.playing = false
      this.hasPlaying = false
    }
  }
  play() {
    const v = this.$refs.videoPlayer as HTMLVideoElement
    if (v.paused || v.ended) {
      // 暂停时点击就播放
      if (v.ended) {
        v.currentTime = 0
      }
      v.play()
    }
  }
  pause() {
    const v = this.$refs.videoPlayer as HTMLVideoElement
    v.pause()
  }
  controlSound() {
    const v = this.$refs.videoPlayer as HTMLVideoElement
    if (v.muted) {
      v.muted = false
      this.hasMuted = false
    } else {
      v.muted = true
      this.hasMuted = true
    }
  }
  openFullScreen() {
    const v = this.$refs.videoPlayer as any
    if (v.webkitRequestFullScreen) {
      v.webkitRequestFullScreen()
    } else if (v.webkitSupportsFullscreen) {
      v.webkitEnterFullscreen()
    }
  }
  closeFullScreen() {
    const v = this.$refs.videoPlayer as any
    if (v.webkitSupportsFullscreen && v.webkitDisplayingFullscreen) {
      v.webkitExitFullscreen()
    } else if ((document as any).webkitCancelFullScreen) {
      const doc = document as any
      doc.webkitCancelFullScreen()
    } else if (document.exitFullscreen) {
      document.exitFullscreen()
    }
  }
  showVideo() {
    this.displayVideo = true
  }
  hideVideo() {
    this.displayVideo = false
  }
  showLoading() {
    this.isLoading = true
  }
  hideLoading() {
    this.isLoading = false
  }
  showError() {
    this.isError = true
  }
  hideError() {
    this.isError = false
  }
  showDashBoard() {
    this.hasDashBoard = true
  }
  hideDashBoard() {
    this.hasDashBoard = false
  }
}
